import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, NgModel, NumberValueAccessor} from '@angular/forms';
import {isArray, isNullOrUndefined} from 'is-what';
import * as _ from 'lodash';
import {DynaCrudService, DynacrudApiWrapper} from 'src/app/core/api/dynacrud-api';
import {OperationType} from 'src/app/core/models/dynacrud';
import {ProductStructureField, Entity} from 'src/app/shared/models/entities';
import {ControlValueAccessorBaseImpl} from '../../../control-value/ControlValueAccessorBaseImpl';
import {SharedService} from "../../../../../shared/services/shared.service";
import {Observable, distinctUntilChanged, take} from "rxjs";
import { localizedName } from 'src/app/shared/i18n/localized-name';
import { AppLocaleService } from 'src/app/shared/services/app-locale.service';

export const STRUCTURE_RAPID_LOOKUP_ACCESSOR_CONTROL_VALUE_ACCESSOR_NORMAL: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => StructureRapidLookUpFieldNormalComponent),
  multi: true
};

@Component({
  selector: 'app-structure-rapid-look-up-field-normal',
  templateUrl: './structure-rapid-look-up-field-normal.component.html',
  styleUrls: ['./structure-rapid-look-up-field-normal.component.scss'],
  providers: [STRUCTURE_RAPID_LOOKUP_ACCESSOR_CONTROL_VALUE_ACCESSOR_NORMAL]
})
export class StructureRapidLookUpFieldNormalComponent extends ControlValueAccessorBaseImpl<Entity> implements OnInit, AfterViewInit {

  @Input()
  structureField!: ProductStructureField;

  private service!: DynaCrudService<Entity>;

  @Input()
  valueSet!: number | undefined;

  @Input()
  showName!: boolean;

  @Input()
  entireData!: any[] | undefined;

  @Input()
  entireDataForce!: boolean;

  @Input() idRowName!: any;


  @Output() getValues = new EventEmitter();

  /** The lookup's own search FAILED — no `getValues` emission will ever follow for this field.
   *  Its consumer keeps the list UNKNOWN (which is what fail-closed means here: `canSaveRow` reads
   *  an unknown `holos` as "a holo is required" and the row template's `*ngIf` keeps the cell
   *  hidden), so without this output the operator was left with rows that simply never became
   *  savable and no message anywhere — the same silent dead-end the restore path's sticky
   *  `lookupLoadFailed` toast already closes, reached through the NORMAL flow instead. Carries the
   *  field so the consumer can say which lookup died. */
  @Output() loadFailed = new EventEmitter<ProductStructureField>();

  @Input() resetAll : Observable<boolean> | undefined;

  @ViewChild('genericField') genericField!: NgModel;

  constructor(private dynacrudApiWrapper: DynacrudApiWrapper, public _elementRef: ElementRef, private sharedService: SharedService, private localeService: AppLocaleService) {
    super();
  }

  ngAfterViewInit(): void {
    this.resetAll?.pipe( distinctUntilChanged() ).subscribe(d => {
      if (d) {
        // `$value` directly — the model→view path `writeValue` uses — NOT the `value` setter.
        // The setter pushes the clear through the base class's DEBOUNCED changeSubject, so the
        // `onChangeCallback(undefined)` landed one task later: after the parent's `resetHeader()`
        // had already lowered its paint-suppression flag. The `[(ngModel)]` write-back then ran
        // the header setter as if the user had cleared the box, painting `undefined` onto every
        // still-active row — wiping the language/condition/holo of exactly the rows the commit
        // had skipped. The parent has already cleared its own model (`valueFiledAll`) inside
        // `resetHeader()`, so there is nothing to report back: a programmatic reset is not input.
        this.$value = undefined;
        this.genericField.valueAccessor?.writeValue('');
        this.entity = undefined as any;
        // this.errorCustom = false;



      }

    });
  }

  onWheel(event: WheelEvent) {
    event.preventDefault();
  }

  // errorCustom = false;

  entity!: Entity;
  entities!: Entity[];

  /** The loaded list, or an empty one — for the LOOKUPS below only.
   *
   *  `entities` is deliberately left UNSET when the lookup fails (see the `error` arm and the
   *  `isArray` guard in `ngOnInit`): "unknown" and "this product offers nothing" are different
   *  answers, and the `nextReloadData` re-emit and the `getValues` channel both depend on telling
   *  them apart — initialising the field to `[]` would silently convert every failure into the
   *  second answer and waive the requirement built on it.
   *
   *  The lookups here need the opposite treatment. They ask "is what the operator typed in the
   *  list", and with no list nothing is, so an unset field must read as no match rather than
   *  throw. It used to throw: the round-12 fail-closed arm turned a failed lookup into an
   *  explicitly supported state — announced by the `lookupLoadFailed` toast, rows blocked until a
   *  re-search — so the operator is now invited to sit in exactly the state where clicking into
   *  the box and tabbing out raised `Cannot read properties of undefined (reading 'find')`. No
   *  match means the box clears, which is the same fail-closed answer: a value that cannot be
   *  validated against a list is not kept. */
  private get loadedEntities(): Entity[] {
    return this.entities ?? [];
  }

  set entityValue(ida: number) {
    
    const id = ida != undefined ? parseInt(ida.toString()) : '';

    this.entity = this.loadedEntities.find(e => e.id?.toString() == id.toString()) as Entity;
    this.value = this.entity?.id;

    if (this.entity && this.entity.id != undefined) {


      this.genericField?.valueAccessor?.writeValue(this.value);
      
      if (this.genericField && (this.genericField.valueAccessor as {
        [k: string]: any
      })['_elementRef']?.nativeElement?.value.toString().length == this.entity.id?.toString().length) {

      } else {

        if ( this.genericField && (this.genericField.valueAccessor as { [k: string]: any })['_elementRef']?.nativeElement) {

          // this.errorCustom = true;
          this.entity = (this.loadedEntities.map(n => {

            if (id && (n.id as number)?.toString().includes(id.toString() as string)) {
              const a: any = {id: '9999999999___santiagolegustaelrealmadriddepeque', name: ''};
              return a;
            }
            return;
          })).find(d => d && d.id != undefined);

          setTimeout(() => {

            this.genericField.valueAccessor?.writeValue(undefined);
            this.value = undefined;

          }, 0);

        }

      }


    } else {

      // this.errorCustom = true;
      this.entity = (this.loadedEntities.map(n => {

        if (id && (n.id as number)?.toString().includes(id.toString() as string)) {
          const a: any = {id: '9999999999___santiagolegustaelrealmadriddepeque', name: ''};
          return a;
        }
        return;
      })).find(d => d && d.id != undefined);

      setTimeout(() => {

        this.genericField.valueAccessor?.writeValue(undefined);
        this.value = undefined;
        // this.errorCustom = true;

      }, 0);
    }

  }

  get entityValue(): any {
    if (this.entity && this.entity.id != undefined) {
      return this.entity.id;
    }
    
    return this.valueSet;
   

  }

  onFocusOutEventEntity(e: FocusEvent) {
    const id = (e.target as any)?.value || '';

    this.entity = this.loadedEntities.find(w => w.id.toString() == id.toString()) as Entity;

    if (!this.entity) {
      setTimeout(() => {
        this.genericField.valueAccessor?.writeValue(undefined);
        this.value = undefined;
        // this.errorCustom = true;

      }, 0);

    }

  }

  override ngOnInit(): void {
    super.ngOnInit();
    const permittedValuse = this.getPermittedValues();

    if ((!this.entireDataForce)) {
      
      if (this.structureField.source) {

        this.service = this.dynacrudApiWrapper.getFor(this.structureField.source);
      }

      // A LOOKUP field declared with no `source` leaves `service` unassigned, and calling `search`
      // on it threw a TypeError straight out of `ngOnInit`. That throw now costs more than a console
      // error: this search is the single place that decides between `getValues` and `loadFailed`, so
      // dying here means the consumer never learns the lookup is unavailable — brand-6 rows stay
      // fail-closed (unknown `holos` ⇒ a holo is required, cell hidden) with no toast to explain it.
      // A field with no source can never produce a list, which is exactly what `loadFailed` says.
      if (!this.service) {
        this.loadFailed.emit(this.structureField);
        return;
      }

      this.service.search(permittedValuse.length > 0 ? {
        filter: {
          filterBy: {
            field: 'id',
            value: permittedValuse,
            operation: OperationType.IN
          }
        }
      } : undefined).subscribe({
        next: ret => {

          // Only a response whose `data` IS an array counts as loaded — the same test the restore
          // path applies (`loadedEntities` in table-edit-rows). A 200 whose body carries null or
          // absent data (backend hiccup, serializer edge) proves nothing about what the product
          // offers: emitting it walked the consumer's attribution path to a null guard, so `holos`
          // stayed UNKNOWN — brand-6 rows unsavable by every path, the cell hidden by its `*ngIf` —
          // while `loadFailed` never fired and no toast ever explained it. That is the same silent
          // dead-end the error arm below exists to close, reached through a malformed body instead
          // of a transport failure, so it takes the same exit.
          if (!isArray(ret?.data)) {
            this.loadFailed.emit(this.structureField);
            return;
          }

          this.entities = ret.data;
          this.getValues.emit(this.entities);

          if (this.valueSet != undefined && typeof this.valueSet == 'number') {
            this.entityValue = this.valueSet;
          }

        },
        // A failed lookup emits NOTHING through `getValues` — deliberately, since fabricating an
        // empty list here would read to the consumer as "this product offers no such value" and
        // waive the requirement built on it. Report the failure on its own channel instead, so the
        // consumer can say so; the list stays unknown, and unknown stays required.
        error: () => this.loadFailed.emit(this.structureField),
      });

    } else {
      this.entities = this.entireData as Entity[];
    }


    this.sharedService.nextReloadData.pipe(distinctUntilChanged()).subscribe(data => {
      // Only re-emit a list we actually HAVE. After a failed search `entities` is undefined, and
      // re-emitting it on every reload tick just walks the consumer's whole attribution path to
      // reach a null guard.
      if (data && this.entities) {
        this.getValues.emit(this.entities);
      }

    });


  }

  public compareEntity(o: any, o2: any) {
    if (isNullOrUndefined(o) && isNullOrUndefined(o2)) {
      return true;
    }

    if ((isNullOrUndefined(o) && !isNullOrUndefined(o2)) || (isNullOrUndefined(o2) && !isNullOrUndefined(o))) {
      return false;
    }

    return o === o2 || o.id === o2.id;
  }

  private getPermittedValues(): number[] {
    let permittedValues: any[] = [];
    let fieldValues = this.structureField.values;
    if (fieldValues && !isArray(fieldValues)) {
      fieldValues = JSON.parse(fieldValues as string);
      if (isArray(fieldValues)) {
        permittedValues = fieldValues as [];
      }
    }
    return permittedValues;
  }


  getDescription() {

    let value: any = this.entity;

    const nomeInitial: any = this.entities?.find(d => (d.id == this.value));

    // (_.isNumber(this.value) || typeof this.value === 'number')
    if ((value && (value.id !== null && value.id !== undefined)) || (_.isNumber(this.value) || typeof this.value as unknown === 'number')) {
      value = value ? value.defaultDescription || localizedName(value, this.localeService.current) || value.description || value.code || value.id : localizedName(nomeInitial, this.localeService.current) || undefined;
      // value  =  value.defaultDescription || value.name || value.description || value.code || value.id  ;
    }


    return value;
  }

  getEntitiesDescription(ent: Entity) {
    let value: any = ent;
    if (value && value.id != null) {
      value = value.defaultDescription || localizedName(value, this.localeService.current) || value.description || value.code || value.id;
    }
    return value;
  }


}
